/* Fixed price ranges inside Umino's dynamic filter section. */
(function () {
  if (window.BlsThemePriceRangesInitialized) return;
  window.BlsThemePriceRangesInitialized = true;

  const workerUrl = 'https://shopify-price-ranges.trandangkhiem1987.workers.dev/ranges';
  const rangeCache = new Map();
  let refreshTimer;

  function getWorkerUrl(container) {
    const url = new URL(workerUrl);
    url.searchParams.set('v', '17');
    url.searchParams.set('collection', container.dataset.collectionHandle);

    const pageUrl = new URL(window.location.href);

    ['filter.p.vendor', 'filter.p.product_type'].forEach(function (param) {
      pageUrl.searchParams.getAll(param).forEach(function (value) {
        url.searchParams.append(param, value);
      });
    });

    return url;
  }

  function updatePriceRangeLinks(container, searchParams) {
    const removeUrl = container.dataset.priceRemoveUrl || '';
    const min = searchParams.get('filter.v.price.gte');
    const max = searchParams.get('filter.v.price.lte');

    container.querySelectorAll('.price-range-link').forEach(function (link) {
      const linkMax = link.dataset.max || null;
      const active = link.dataset.min === min && linkMax === max;
      const item = link.closest('.item');
      const checkbox = link.querySelector('.checkbox');

      link.classList.toggle('active', active);
      if (item) item.classList.toggle('current-filter', active);
      if (checkbox) checkbox.classList.toggle('checked', active);

      if (active && removeUrl) {
        link.href = removeUrl;
        return;
      }

      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      url.searchParams.set('filter.v.price.gte', link.dataset.min);

      if (link.dataset.max) {
        url.searchParams.set('filter.v.price.lte', link.dataset.max);
      } else {
        url.searchParams.delete('filter.v.price.lte');
      }

      link.href = url.pathname + url.search;
    });
  }

  async function refreshPriceRanges() {
    const containers = Array.from(
      document.querySelectorAll(
        '.price-range-filter[data-collection-handle]'
      )
    );

    if (!containers.length) return;

    const searchParams = new URL(window.location.href).searchParams;

    containers.forEach(function (container) {
      updatePriceRangeLinks(container, searchParams);
    });

    await Promise.all(containers.map(async function (container) {
      const url = getWorkerUrl(container);
      const cacheKey = url.toString();

      if (!rangeCache.has(cacheKey)) {
        rangeCache.set(
          cacheKey,
          fetch(cacheKey)
            .then(function (response) {
              if (!response.ok) throw new Error('Price range request failed');
              return response.json();
            })
            .then(function (data) {
              return new Set(data.ranges.map(function (range) {
                return range.min + ':' + range.max;
              }));
            })
            .catch(function () {
              rangeCache.delete(cacheKey);
              return null;
            })
        );
      }

      const ranges = await rangeCache.get(cacheKey);
      if (!ranges) return;

      container.querySelectorAll('.price-range-link').forEach(function (link) {
        const key = link.dataset.min + ':' + (link.dataset.max || 'null');
        link.hidden = !ranges.has(key);
      });
    }));
  }

  function queueRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshPriceRanges, 50);
  }

  const collectionSection = document.querySelector('.section-collection-product');
  const collectionParent = collectionSection && collectionSection.parentNode;

  if (collectionParent) {
    new MutationObserver(queueRefresh).observe(
      collectionParent,
      { childList: true }
    );
  }

  queueRefresh();
})();